;(function (angular, $) {
    'use strict';
    angular.module('digitickApp').controller('AsideMyAccountController', ['$scope', 'AuthService', '$sce', function ($scope, AuthService, $sce) {
        $scope.AuthService = AuthService;
        $scope.isFocus = false;

        $scope.urlConnect = $sce.trustAsResourceUrl(getUrlLegacy('ext/digitick/index.php?p=1001&langue='+document.documentElement.lang));
        $scope.locationSelected = null;
        $scope.country = {
            id: 1,
            name: 'France',
            isoCode: 'FR'
        };


        var countries = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            prefetch: getUrl('business/countries')
        });

        // initialize the bloodhound suggestion engine
        countries.initialize();

        // Typeahead options object
        $scope.options = {
            hint: true,
            highlight: true,
            minLength: 1,
            classNames: {
                menu: 'tt-dropdown-menu'
            }
        };
        // Multiple dataset example
        $scope.datas = [
            {
                name: 'countries',
                displayKey: 'name',
                source: countries.ttAdapter(),
                templates: {
                    suggestion: function(country){
                        var r = '<div><span class="flag-icon flag-icon-'+angular.lowercase(country.isoCode)+'"></span> '+country.name+'</div>';
                        return r;
                    }
                }
            }
        ];

        $scope.$on('typeahead:selected', function(ev, country){
            $scope.country = country;
            $scope.$apply();
        });
    }]);
})(angular, jQuery);
